<div class="flex h-screen overflow-hidden bg-gray-100">

  <!-- Backdrop mobile -->
  @if (sidebarOpen()) {
    <div
      class="fixed inset-0 z-20 bg-black/50 md:hidden"
      (click)="closeSidebar()"
    ></div>
  }

  <!-- Sidebar -->
  <app-sidebar [open]="sidebarOpen()" (closeRequest)="closeSidebar()" />

  <!-- Main Content -->
  <main class="flex-1 flex flex-col min-w-0 overflow-y-auto bg-gray-100">

    <!-- Top bar mobile -->
    <div class="md:hidden flex items-center gap-3 px-4 py-3 bg-blue-900 text-white shrink-0">
      <button
        type="button"
        (click)="toggleSidebar()"
        aria-label="Abrir menú"
        class="text-white"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
        </svg>
      </button>
      <span class="font-bold text-lg">SGCAP</span>
    </div>

    <!-- Content -->
    <div class="p-4 md:p-8 bg-gray-100">
      <router-outlet></router-outlet>
    </div>
  </main>

  <!-- Floating Cart Button (oculto para operario) -->
  @if (!permisos.esOperario) {
  <button
    type="button"
    (click)="toggleCart()"
    class="fixed bottom-6 right-6 z-30 w-14 h-14 bg-blue-600 text-white rounded-full shadow-lg hover:bg-blue-700 hover:scale-105 transition-all flex items-center justify-center"
    aria-label="Carrito de pedido"
  >
    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
    </svg>
    @if (totalItems() > 0) {
      <span class="absolute -top-1 -right-1 w-6 h-6 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center">
        {{ totalItems() > 99 ? '99+' : totalItems() }}
      </span>
    }
  </button>
  }

  <!-- Cart Drawer -->
  @if (!permisos.esOperario) {
    <app-cart-drawer [isOpen]="cartOpen()" (onClose)="closeCart()" />
  }
</div>
